import { watchEntities, findEntities, getEntity, updateEntity, deleteEntity, createEntity, unwatchEntities } from './EntitiesSagas';
import { AssetsActions } from '../reducers/AssetsRedux';

export function* watchAssets(api) {
    yield watchEntities(api, 'asset', AssetsActions);
}
export function* unwatchAssets(api){
  yield unwatchEntities(api, 'asset', AssetsActions)
}

export function* findAssets(api, action) {
  yield findEntities(api, 'asset', AssetsActions, action);
}

export function* getAsset(api, action) {
  yield getEntity(api, AssetsActions, action);
}

export function* updateAsset(api, action) {
  yield updateEntity(api, AssetsActions, action);
}

export function* deleteAsset(api, action) {
  yield deleteEntity(api, AssetsActions, action);
}

export function* createAsset(api, action) {
  yield createEntity(api, AssetsActions, action);
}